import { Home } from "lucide-react";
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-12 bg-muted/50" role="contentinfo" aria-label="Footer">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Home className="w-8 h-8 text-primary" />
              <span className="text-xl font-bold text-foreground">TPS Housing</span>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.home')}
                </a>
              </li>
              <li>
                <a href="#why" className="text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.whyTPS')}
                </a>
              </li>
              <li>
                <a href="#services" className="text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.services')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-muted-foreground hover:text-primary transition-colors">
                  {t('footer.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground">{t('footer.contact')}</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <a href="mailto:info@tpshousing.com" className="hover:text-primary transition-colors">
                  info@tpshousing.com
                </a>
              </li>
              <li>
                <a href="tel:760-687-1001" className="hover:text-primary transition-colors">
                  760-687-1001
                </a>
              </li>
              <li className="pt-4">
                <div className="font-semibold mb-1 text-foreground">{t('footer.mailingAddress')}</div>
                <div>10810 N. Tatum Blvd. #102-222</div>
                <div>Phoenix, AZ 85028</div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} TPS Housing. {t('footer.rights')}</p>
          <div className="flex items-center justify-center gap-4 mt-2">
            <a href="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors text-sm">
              Privacy Policy
            </a>
            <span className="text-border">|</span>
            <a href="/terms-of-service" className="text-muted-foreground hover:text-primary transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
